module.exports = __webpack_public_path__ + "static/media/whitem.5ce08b78.png";